module.exports = __webpack_public_path__ + "img/schemeList09-4.87efae5e.png";